export default __webpack_public_path__ + "static/media/1.6e6ceb92.png";